(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ccla-attribution-links"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  if (window.cclaAttributionLinksInitialized) return;
  window.cclaAttributionLinksInitialized = true;

  var campaignId = '24420705302';
  var adRefs = [
    'ccla_search_logo_20261102_a7c4',
    'ccla_search_corporate_20261102_b9e2'
  ];
  var keys = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term',
    'utm_content', 'ad_ref', 'campaign_id', 'ad_group_id', 'ad_id',
    'gclid', 'gbraid', 'wbraid', 'google_adgroup_id', 'google_ad_id'
  ];
  var originals = new WeakMap();
  var ownershipAttribute = 'data-ccla-attribution-added';
  var consentRequested = false;

  function incomingContext() {
    var params = new URL(window.location.href).searchParams;
    var context = {};
    for (var i = 0; i < keys.length; i++) {
      var values = params.getAll(keys[i]);
      if (values.length > 1) return null;
      if (values.length === 1 && values[0].trim()) {
        if (values[0].length > 512) return null;
        context[keys[i]] = values[0];
      }
    }
    if ((params.has('campaign_id') && context.campaign_id !== campaignId) ||
        (params.has('utm_id') && context.utm_id !== campaignId)) return null;
    if (params.has('ad_ref') && adRefs.indexOf(context.ad_ref) === -1) return null;
    if (params.has('ad_ref') && params.has('utm_content') &&
        context.ad_ref !== context.utm_content) return null;
    var matches = context.campaign_id === campaignId ||
      context.utm_id === campaignId ||
      adRefs.indexOf(context.ad_ref) !== -1 ||
      adRefs.indexOf(context.utm_content) !== -1;
    return matches ? context : null;
  }

  function permittedContext() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.marketingAllowed !== 'function' ||
          privacy.marketingAllowed() !== true) return null;
      return incomingContext();
    } catch (_) {
      return null;
    }
  }

  function destinationHref(anchor, original, context) {
    if (!context || !original || original.charAt(0) === '#' ||
        anchor.hasAttribute('download')) return original;
    try {
      var destination = new URL(original, document.baseURI);
      var current = new URL(window.location.href);
      if (destination.origin !== current.origin || destination.username ||
          destination.password || !/^https?:$/.test(destination.protocol)) {
        return original;
      }
      var contentPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:pages|products|collections|blogs|search)(?:\/|$)/i;
      var homePath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i;
      if (!contentPath.test(destination.pathname) &&
          !homePath.test(destination.pathname)) return original;
      for (var i = 0; i < keys.length; i++) {
        if (destination.searchParams.has(keys[i])) return original;
      }
      Object.keys(context).forEach(function (key) {
        destination.searchParams.set(key, context[key]);
      });
      return destination.href.length <= 4096 ? destination.href : original;
    } catch (_) {
      return original;
    }
  }

  function updateAnchor(anchor, context) {
    if (!anchor || !anchor.matches || !anchor.matches('a[href]')) return;
    var current = anchor.getAttribute('href');
    var record = originals.get(anchor);
    var original = record && current === record.applied ? record.original :
      withoutOwnedParameters(current, record ? record.owned : readOwnership(anchor));
    var next = destinationHref(anchor, original, context);
    var owned = next !== original ? context : null;
    originals.set(anchor, { original: original, applied: next, owned: owned });
    if (owned) {
      var serialized = JSON.stringify(owned);
      if (anchor.getAttribute(ownershipAttribute) !== serialized) {
        anchor.setAttribute(ownershipAttribute, serialized);
      }
    } else if (anchor.hasAttribute(ownershipAttribute)) {
      anchor.removeAttribute(ownershipAttribute);
    }
    if (current !== next) anchor.setAttribute('href', next);
  }

  function readOwnership(anchor) {
    try {
      var raw = anchor.getAttribute(ownershipAttribute);
      if (!raw || raw.length > 8192) return null;
      var value = JSON.parse(raw);
      if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
      var owned = {};
      Object.keys(value).forEach(function (key) {
        if (keys.indexOf(key) !== -1 && typeof value[key] === 'string' &&
            value[key].length <= 512) owned[key] = value[key];
      });
      return owned;
    } catch (_) {
      return null;
    }
  }

  function withoutOwnedParameters(href, owned) {
    if (!href || !owned) return href;
    try {
      var url = new URL(href, document.baseURI);
      var cleaned = new URLSearchParams();
      var removed = {};
      var changed = false;
      url.searchParams.forEach(function (value, key) {
        if (!removed[key] && Object.prototype.hasOwnProperty.call(owned, key) &&
            value === owned[key]) {
          removed[key] = true;
          changed = true;
        } else {
          cleaned.append(key, value);
        }
      });
      if (!changed) return href;
      url.search = cleaned.toString();
      return url.href;
    } catch (_) {
      return href;
    }
  }

  function updateTree(node, context) {
    updateAnchor(node, context);
    if (!node || !node.querySelectorAll) return;
    node.querySelectorAll('a[href]').forEach(function (anchor) {
      updateAnchor(anchor, context);
    });
  }

  function refresh() {
    updateTree(document, permittedContext());
  }

  function refreshAndLoadConsent() {
    refresh();
    if (consentRequested || !incomingContext()) return;
    var shopify = window.Shopify;
    if (!shopify || typeof shopify.loadFeatures !== 'function') return;
    if (shopify.customerPrivacy &&
        typeof shopify.customerPrivacy.marketingAllowed === 'function') return;
    consentRequested = true;
    try {
      shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.2' }
      ], function (error) {
        if (!error) refresh();
      });
    } catch (_) {}
  }

  function updateEventLink(event) {
    var target = event.target;
    var anchor = target && target.closest && target.closest('a[href]');
    updateAnchor(anchor, permittedContext());
  }

  function start() {
    refreshAndLoadConsent();
    var observer = new MutationObserver(function (mutations) {
      var context = permittedContext();
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          updateAnchor(mutation.target, context);
        } else {
          mutation.addedNodes.forEach(function (node) {
            updateTree(node, context);
          });
        }
      });
    });
    observer.observe(document.body, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['href']
    });
    ['pointerdown', 'click', 'contextmenu'].forEach(function (name) {
      document.addEventListener(name, updateEventLink, true);
    });
    document.addEventListener('visitorConsentCollected', refresh);
    window.addEventListener('pageshow', refreshAndLoadConsent);
    window.addEventListener('popstate', refreshAndLoadConsent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
